export default __webpack_public_path__ + "static/media/user-account-settings.a5a21e82.svg";